





































import {Component, Vue} from 'vue-property-decorator';
import {AuthTokenDto} from "@/oauth/AuthTokenDto";

@Component({
  components: {},
})
export default class RegisterSuccess extends Vue {
  suc() {
    AuthTokenDto.logout();
    this.$router.push({name: 'login'});
  }
}
